import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './index.module.scss';
import cn from 'classnames';
import ContentLoader from 'react-content-loader';
const DEFAULT_SIZES = {
    width: 30,
    height: 30
};
const PlaceholderLoader = ({ type, width = DEFAULT_SIZES.width, height = DEFAULT_SIZES.height, repeat = 1, axis = 'vertical', darkMode }) => {
    const buildShape = (_type, idx) => {
        switch (_type) {
            case 'rect':
                return (_jsx("rect", { className: cn(styles.elem), x: "0", y: "0", rx: "5", ry: "5", width: width, height: height }, idx));
            case 'circle':
                return (_jsx("circle", { className: cn(styles.elem), rx: "5", ry: "5", width: width, height: height }, idx));
        }
    };
    const placeholderShapes = () => {
        const arr = [];
        for (let i = 0; i < repeat; i++) {
            arr.push(buildShape(type, i));
        }
        return [...arr];
    };
    placeholderShapes();
    return (_jsx(ContentLoader, Object.assign({ backgroundColor: darkMode ? '#1C1F2A' : '#C7C7C7', foregroundColor: darkMode ? '#161821' : 'white', speed: 1, viewBox: "0 0 380 70", className: cn(styles.wrapper) }, { children: placeholderShapes() })));
};
export default PlaceholderLoader;
